import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentMethodCard = ({ method, isDefault, onSetDefault, onRemove, onEdit }) => {
  const getCardIcon = (type) => {
    const icons = {
      visa: 'CreditCard',
      mastercard: 'CreditCard',
      amex: 'CreditCard',
      sepa: 'Building2'
    };
    return icons?.[type] || 'CreditCard';
  };

  const getCardBrand = (type) => {
    const brands = {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      sepa: 'Prélèvement SEPA'
    };
    return brands?.[type] || type;
  };

  return (
    <div className={`bg-card rounded-lg border ${isDefault ? 'border-primary' : 'border-border'} p-4 relative`}>
      {isDefault && (
        <div className="absolute top-2 right-2">
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
            <Icon name="Check" size={12} />
            Par défaut
          </span>
        </div>
      )}
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
          <Icon name={getCardIcon(method?.type)} size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1">
            {getCardBrand(method?.type)}
          </h4>
          <p className="text-sm text-muted-foreground">
            {method?.type === 'sepa' ? method?.iban : `•••• •••• •••• ${method?.last4}`}
          </p>
          {method?.expiryDate && (
            <p className="text-xs text-muted-foreground mt-1">
              Expire le {method?.expiryDate}
            </p>
          )}
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {!isDefault && (
          <Button
            variant="outline"
            size="xs"
            iconName="Star"
            onClick={() => onSetDefault(method?.id)}
          >
            Définir par défaut
          </Button>
        )}
        <Button
          variant="ghost"
          size="xs"
          iconName="Edit2"
          onClick={() => onEdit(method?.id)}
        >
          Modifier
        </Button>
        <Button
          variant="ghost"
          size="xs"
          iconName="Trash2"
          onClick={() => onRemove(method?.id)}
          className="text-error hover:text-error"
        >
          Supprimer
        </Button>
      </div>
    </div>
  );
};

export default PaymentMethodCard;